import ApplicationActions, {
   isFetchingApplicationSuccess,
   getApplications,
} from 'pgdb-data-layer/lib/Redux/ApplicationsRedux';
import LicenceActions, {
   getLicenceData,
   isFetchingLicence,
} from 'pgdb-data-layer/lib/Redux/LicenceRedux';
import { APPLICATION_RENEWAL_STATE } from 'pgdb-data-layer/lib/Constants/Application';
import {
   getDescription,
   calculateUserRenewals,
} from 'pgdb-data-layer/lib/Helpers/DashboardCards';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DashboardCard from '../index';
import { getToken } from '../../../Session/SessionRedux';

export class RenewalCard extends Component {
   constructor(props) {
      super(props);
      this.state = {
         renewalState: APPLICATION_RENEWAL_STATE.NotStarted,
      };
   }

   componentDidMount() {
      const { dispatch, token, userLicence } = this.props;
      dispatch(ApplicationActions.getApplicationsByUserRequest(token));
      if (
         !userLicence.currentLicences ||
         userLicence.currentLicences.length === 0
      ) {
         dispatch(LicenceActions.licenceRequest(token));
      }
   }

   componentDidUpdate(prevProps) {
      const { applications } = this.props;
      if (applications !== prevProps.applications) {
         this.calculateUserRenewals();
      }
   }

   calculateUserRenewals() {
      const { applications } = this.props;
      const { renewalState } = this.state;
      const newRenewalState = calculateUserRenewals(applications, renewalState);
      this.setState({
         renewalState: newRenewalState,
         applications,
      });
   }

   // Visibility comes from /Licences, the same source as the Licences page this
   // tile links to, so the tile and the page can never disagree. Mirrors the
   // emptiness test in Containers/Pages/Licences.js. Note currentData is always
   // a non-null object, so it cannot be used as a truthiness check.
   hasLicenceData() {
      const { userLicence } = this.props;
      const { currentLicences, nextLicences } = userLicence;
      return (
         (currentLicences && currentLicences.length > 0) ||
         (nextLicences && nextLicences.length > 0)
      );
   }

   render() {
      const { renewalState, applications } = this.state;
      const startRenewNavLink = {
         href: 'renew',
         text: 'Renew',
      };
      const completedRenewNavLink = {
         href: 'licences',
         text: 'View Details',
      };
      const { isLoading, isLoadingLicence } = this.props;
      const shouldShowTile =
         !isLoading && !isLoadingLicence && this.hasLicenceData();

      return shouldShowTile ? (
         <DashboardCard
            header="Licensing"
            icon="style"
            iconStyle="grey2-text"
            description={getDescription(applications, renewalState)}
            navLink={
               renewalState === APPLICATION_RENEWAL_STATE.NotStarted ||
               renewalState === APPLICATION_RENEWAL_STATE.InProgress
                  ? startRenewNavLink
                  : completedRenewNavLink
            }
            visible
            disabled={false}
         />
      ) : null;
   }
}

RenewalCard.defaultProps = {
   isLoading: true,
   isLoadingLicence: true,
   userLicence: {},
};

RenewalCard.propTypes = {
   applications: PropTypes.array,
   dispatch: PropTypes.func.isRequired,
   token: PropTypes.string.isRequired,
   isLoading: PropTypes.bool,
   isLoadingLicence: PropTypes.bool,
   userLicence: PropTypes.object,
};

const mapStateToProps = state => {
   return {
      applications: getApplications(state),
      token: getToken(state),
      isLoading: !isFetchingApplicationSuccess('getApplicationsByUser', state),
      userLicence: getLicenceData(state),
      isLoadingLicence: isFetchingLicence(state),
   };
};

export default connect(mapStateToProps)(RenewalCard);
